import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { downloadBlob } from "../lib/download";
import { FileText } from "lucide-react";

const inputCls = "px-3 py-2 bg-white border border-[var(--parchment-2)] focus:border-[var(--maroon)] outline-none text-sm";

export const IncidentsBulletin = () => {
  const [classes, setClasses] = useState([]);
  const [start, setStart] = useState("");
  const [end, setEnd] = useState("");
  const [classId, setClassId] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/classes").then(({ data }) => setClasses(data.filter((c) => !c.id.startsWith("lvl:"))));
  }, []);

  const download = async () => {
    setBusy(true);
    const params = {};
    if (start) params.start = start;
    if (end) params.end = end;
    if (classId) params.class_id = classId;
    await downloadBlob("/admin/incidents.pdf", "bulletin-signalements.pdf", "Bulletin des signalements téléchargé", "Échec de la génération du bulletin", params);
    setBusy(false);
  };

  return (
    <div className="mt-6 bg-white border border-[var(--parchment-2)] p-4 flex flex-wrap items-end gap-3" data-testid="incidents-bulletin">
      <div>
        <label className="eyebrow block mb-1">Du</label>
        <input type="date" className={inputCls} value={start} onChange={(e) => setStart(e.target.value)} data-testid="incidents-bulletin-start" />
      </div>
      <div>
        <label className="eyebrow block mb-1">Au</label>
        <input type="date" className={inputCls} value={end} onChange={(e) => setEnd(e.target.value)} data-testid="incidents-bulletin-end" />
      </div>
      <div>
        <label className="eyebrow block mb-1">Classe</label>
        <select className={inputCls} value={classId} onChange={(e) => setClassId(e.target.value)} data-testid="incidents-bulletin-class">
          <option value="">Toutes</option>
          {classes.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </select>
      </div>
      <button
        className="btn-primary !py-2 !px-4 text-sm flex items-center gap-2 disabled:opacity-50"
        onClick={download}
        disabled={busy}
        data-testid="incidents-bulletin-btn"
      >
        <FileText size={15} /> {busy ? "Génération..." : "Bulletin PDF des signalements"}
      </button>
      <span className="text-xs text-[var(--muted)]">Sans dates : tous les signalements de l'année.</span>
    </div>
  );
};
